// extracted by mini-css-extract-plugin
export default {"shimmer":"_e0f120cd","shimmerLoadingBackground":"_2a2f1145","spacer":"_88a4d6be"};